import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import Img from '../../assets/plants.png'
import Img1 from '../../assets/plants2.png'
const Admin = () => {
    return (
      <div>
        <Navbar />

        <section className="min-h-screen bg-green-200">
          <div>
            <div className="AdminWork bg-green-200">
              <div className="flex flex-col justify-center mr-1.5 items-center">
                <div className="mb-2 text-lg font-semibold text-green-900 dark:text-white bg-gradient-to-l from-green-200 to-green-500">
                  As an Admin you can:
                </div>
                <ul className="space-y-1 max-w-md list-inside text-black-500 dark:text-black-400">
                  <li className="flex items-center bg-gradient-to-r from-green-200 to-green-400">
                    <svg
                      className="w-4 h-4 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    Add Content
                  </li>
                  <li className="flex items-center bg-gradient-to-r from-green-200 to-green-400">
                    <svg
                      className="w-4 h-4 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    Add New Pages
                  </li>
                  <li className="flex items-center bg-gradient-to-r from-green-200 to-green-400">
                    <svg
                      className="w-4 h-4 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    Publish Content
                  </li>
                  <li className="flex items-center bg-gradient-to-r from-green-200 to-green-400">
                    <svg
                      className="w-4 h-4 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    Edit Site Settings
                  </li>
                  <li className="flex items-center bg-gradient-to-r from-green-200 to-green-400">
                    <svg
                      className="w-4 h-4 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    Monitor Content
                  </li>
                </ul>
              </div>
            </div>
          </div>
        <div className='mt-2 w-full h-[1px] bg-white'>

        </div>
          <div className="flex flex-wrap justify-center mt-10">
            <div className="  object-cover">
              <img
                loading="lazy"
                src={Img}
                alt="plants className"
                style={{ width: "500px" }}
              />
            </div>
            <div className="  object-cover ">
              <img
                loading="lazy"
                src={Img1}
                alt="plants className"
                style={{ width: "500px" }}
              />
            </div>
            <div className=" object-cover">
              <img
                loading="lazy"
                src={Img}
                alt="plants className"
                style={{ width: "500px" }}
              />
            </div>
          </div>
        </section>

        <div
          className="flex flex-row justify-center text-center text-white w-full "
          style={{ backgroundColor: "#caced1" }}
        >
          <div className="container p-6 w-full">
            <div className="grid lg:grid-cols-10 md:grid-cols-3 gap-4 justify-around">
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/34982557?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/33022181?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/45671265?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/36660485?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/79130019?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/82962869?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>

              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/77690187?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>

              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/52147191?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/79748804?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
              <div className="lg:mb-0 mb-6">
                <img
                  loading="lazy"
                  src="https://avatars.githubusercontent.com/u/76878314?v=4"
                  className="w-full rounded-md shadow-lg"
                  alt="..."
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
}

export default Admin